/* eslint-disable react/jsx-no-literals */
import Typography from 'apollo-react/components/Typography';
import React from 'react';

import IQVIAFooter from '../../../assets/images/IQVIA-footer.svg';

function LoginFooter() {
  const currentYear = new Date().getFullYear();

  return (
    <>
      <div className="login-footer">
        <img className="logo" src={IQVIAFooter} alt="IQVIA footer" />
        <a
          className="link"
          href="https://www.iqvia.com/about-us/terms-of-use"
          target="_blank"
          rel="noopener noreferrer"
        >
          <Typography variant="subtitle1" color="primary">
            {'Terms of use'}
          </Typography>
        </a>
        <a
          className="link"
          href="https://www.iqvia.com/about-us/privacy"
          target="_blank"
          rel="noopener noreferrer"
        >
          <Typography variant="subtitle1" color="primary">
            {'Privacy Policy'}
          </Typography>
        </a>
        <Typography style={{ marginLeft: 'auto' }} variant="caption">
          &copy; {currentYear}. All rights reserved. IQVIA&#174; is a registered trademark of IQVIA
          Inc. in the United States, the European Union, and various other countries.
        </Typography>
      </div>
    </>
  );
}

export default LoginFooter;
